(function () {
    'use strict';

    run.parts.phoneFieldCountrySelector = function () {

        jQuery(document).ready(function($) {
            if ($('.phone_field_with_code').length) {
                $(".phone_field_with_code").CcPicker({
                    dataUrl: "/assets/lib/jquery-country-code-picker/data.json"
                });

                if ($('#phone_country_code').val().length) {
                    $(".phone_field_with_code").CcPicker("setCountryByPhoneCode", $('#phone_country_code').val());
                }
                else {
                    $(".phone_field_with_code").CcPicker("setCountryByCode", 'us');
                }

                $('.phone_field_with_code').on("countrySelect", function(e, i){
                    if ($('#phone_country_code').length) {
                        $('#phone_country_code').val(i.phoneCode);
                    }
                    // console.log(i.phoneCode);
                });
            }
        });
    };
})();